<template>
    <div @click="closeModal()" class="product-modal">
        <div v-on:click.stop class="product-modal-container no-scrollbar">
            <div class="main-container">
                <div class="second-container mobile">
                    <div class="info-container">
                        <p v-if="!isSelected && !canAdd" class="oops">Oops!</p>
                        <p v-if="title" class="main-title">{{ title }}</p>
                        <p class="product-title">{{ product.title }}</p>
                        <div v-if="maxQty > 1 && !showAllVariants" class="box-qty-input-container">
                            <button :disabled="selectedQty < 2" @click="incrementBoxQty(false)">-</button> 
                            <input :disabled="true" v-model="selectedQty" type="number" min="1"> 
                            <button :disabled="selectedQty == maxQty" @click="incrementBoxQty(true)">+</button> 
                        </div>
                    </div>
                </div>
                <div class="first-container">
                    <div class="image-container mobile">
                        <VueSlickCarousel :infinite="true" :arrows="false" :slidesToShow="1" :slidesToScroll="1" :draggable="true" :dots="true">
                            <img class="main-image" v-for="image in product.images" :key="image.id" :src="image.src"/>
                        </VueSlickCarousel>
                    </div>
                    <div class="image-container desktop">
                        <img :src="currentMainImage" class="main-image">
                        <div v-if="product.images.length > 1" class="extra-images-container">
                            <img 
                                v-for="image in product.images" 
                                :key="image.id"
                                class="extra-image"
                                :class="image.src == currentMainImage ? 'selected' : ''"
                                :src="image.src"
                                @click="selectImage(image.src)"
                            >
                        </div>
                    </div>
                </div>
                <div class="second-container" :class="showAllVariants && hasVariants ? 'reverse' : ''">
                    <div class="info-container">
                        <p v-if="!isSelected && !canAdd" class="oops desktop">Oops!</p>
                        <p v-if="title" class="main-title desktop">{{ title }}</p>
                        <p class="product-title desktop">{{ product.title }}</p>
                        <p v-html="description" class="main-description"></p>
                        <template v-if="showAllVariants && hasVariants">
                        <div class="variant-container">
                            <p class="variant-title">Choose options: (Max: {{ maxQty }})</p>
                            <div class="sizes-selection-container">
                                <div v-for="(variant,i) in displaySizes" class="size-selection">
                                    <p>{{ variant.name }}</p>
                                    <input min="0" :max="variant.maxQty" v-model="displaySizes[i].qty"  @input="validateVariantQty(i)" type="number">
                                </div>
                            </div>
                        </div>
                        </template>
                        <template v-else>
                            <p class="variant-text" :class="showAlert ? 'red' : ''"  v-if="hasVariants">Please choose one</p>
                            <div v-if="hasVariants">
                                <select v-model="selectedVariant" id="variantSelector">
                                    <option v-for="variant in variantOptions" :key="variant.id" :value="variant">{{variant.title.replaceAll("Price /","").replaceAll("Happy Choice /","")}}</option>
                                </select>
                            </div>
                            <div v-if="extraProperties.length > 0">
                                <div v-for="(property,i) in extraProperties">
                                    <p class="variant-text"  :class="showExtraAlert ? 'red' : ''">{{ property.name }}</p>
                                    <select v-model="propertiesSelected[i]" @change="changeProperty($event,property)">
                                        <option v-for="variant in property.values" :key="variant" :value="variant">{{variant}}</option>
                                    </select>
                                </div>
                            </div>
                            <div v-for="input in extraInputs" :key="input.name" class="form-group flex flex-column m-t-05rem">
                                <label :for="input.name" class="body-small" :class="showExtraAlert ? 'color-warning' : ''">{{ input.label || input.name }}</label>
                                <template v-if="['text', 'number', 'color'].includes(input.type)">
                                    <input 
                                        :type="input.type" 
                                        :id="input.name" 
                                        v-model="formData[input.name]" />
                                </template>
                            </div>
                            <div v-if="maxQty > 1" class="box-qty-input-container desktop">
                                <button :disabled="selectedQty < 2" @click="incrementBoxQty(false)">-</button> 
                                <input :disabled="true" v-model="selectedQty" type="number" min="1"> 
                                <button :disabled="selectedQty == maxQty" @click="incrementBoxQty(true)">+</button> 
                            </div>
                        </template>
                    </div>
                    <template v-if="showAllVariants && hasVariants">
                        <div class="buttons-container">
                            <button v-if="allQtySelected === 0" disabled="disabled" class="happybox-button green disabled">Pick Your Shirts Above</button>
                            <button v-else-if="allQtySelected > 0 && !shouldNextStep" @click="addAllVariants()" class="happybox-button green border" >Submit {{ allQtySelected }} Shirts</button>
                            <button v-else @click="checkout()" class="happybox-button green border" :class="isLoading ? 'isLoading' : ''">Next Step</button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="buttons-container">
                            <button v-if="maxQty > 1 && isSelected && availableCapacity > 0 && cartDiff == 0" @click="closeModal()" class="happybox-button green border" >Add More Gifts</button>
                            <button v-if="maxQty > 1 && cartDiff != 0 && isSelected && canAdd" @click="selectProduct()" class="happybox-button green border">Update gift quantity</button>
                            <button v-if="maxQty > 1 && cartDiff != 0 && isSelected && !canAdd" @click="selectProduct(true)" class="happybox-button green border">Clean cart and update gift</button>
                            <button v-if="(isSelected && !isBundle) || (isSelected && isBundle && bundleRemaining == 0 && tabCapacity == 0)" @click="checkout" :class="[isLoading ? 'isLoading' : '',(availableCapacity != 0 || (maxQty > 1 && cartDiff != 0 && isSelected)) ? 'gray' : 'green']" :disabled="availableCapacity != 0 || (maxQty > 1 && cartDiff != 0 && isSelected)" class="happybox-button border">Next Step: Add your Address</button>
                            <button v-else-if="isSelected && isBundle && bundleRemaining > 0 && tabCapacity == 0" @click="nextStep"  class="happybox-button green border">Next Step</button>
                            <button v-else-if="isSelected && isBundle && bundleRemaining > 0 && tabCapacity > 0" @click="closeModal()"  class="happybox-button green border">Pick next gift</button>
                            <button v-else-if="canAdd" @click="selectProduct()" class="happybox-button green border">{{isOneRedeem ? 'Submit' : 'Redeem this gift'}}</button>
                            <button v-else @click="selectProduct(true)" class="happybox-button green border">Replace with this gift</button>
                        </div>
                    </template>
                    
                </div>
                <img @click="closeModal()" class="close"  src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x">
            </div>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    data(){
        return{
            selectedImage: null,
            selectedQty: 1,
            selectedVariant: null,
            propertiesSelected: [],
            showAlert: false,
            showExtraAlert: false,
            displaySizes: null,
            formData: {},
        }
    },
    components:{
        VueSlickCarousel
    },
    props:{
        product: Object,
        cartProducts: Array,
        availableCapacity: Number,
        isLoading: Boolean,
        collectionValue: Number,
        isBundle: Boolean,
        tabs: Array,
        isOneRedeem:Boolean,
        collectionHandle: String,
    },
    computed:{
        isSelected(){
            return this.cartProducts.find(x => x.variants[0].id == this.currentVariant.id)
        },
        currentVariant(){
            if(this.selectedVariant){
                return this.selectedVariant
            }

            return this.product.variants[0];
        },
        productCapacity(){
            let value = 0
            let tags = this.product.tags.split(", ");
            let valueTag = tags.find(y => y.toLowerCase().includes("goc_capacity_"))
            if(valueTag){
              valueTag = valueTag.split("_")[2];

              value = parseInt(valueTag);
            }
            let customValue = tags.find(y => y.toLowerCase().includes(`custom_capacity_${this.collectionHandle}`));
            if(customValue){
              customValue = customValue.split("_")[3];

              value = parseInt(customValue);
            }
            return value;
        },
        variantOptions(){
           return this.product.variants.filter(x => x.inventory_quantity > 0);
        },
        hasVariants(){
            return this.product.variants.length > 1;
        },
        extraProperties(){
            if(this.product.tags.includes("Properties_")){
                let tags = this.product.tags.split(",");
                let propertiesTags = tags.filter(x => x.includes("Properties_"));

                return propertiesTags.map((x) => {
                    let splittedTag = x.split("_");
                    let values = splittedTag[splittedTag.length - 1].split("-");

                    return {name: splittedTag[1],values: values}
                })
            }

            return []
        },
        extraInputs(){
            if(this.product.tags.includes("Input_")){
                let tags = this.product.tags.split(",");
                let propertiesTags = tags.filter(x => x.includes("Input_"));

                return propertiesTags.map((x) => {
                    let splittedTag = x.split("_");
                    return {name: splittedTag[1],type: splittedTag[2].toLowerCase()}
                })
            }

            return []
        },
        canAdd(){ 
            if(this.isBundle)
                return (this.selectedQty - this.cartQty) <= this.tabs[this.product.tab].currentQty
            else
                return (this.productCapacity * (this.selectedQty - this.cartQty)) <= this.availableCapacity
        },
        cartQty(){
            if(this.isSelected && this.isSelected.qty){
                return this.isSelected.qty;
            }

            return 0
        },
        cartDiff(){
            return this.cartQty - this.selectedQty;
        },
        maxQty(){
            if(this.isBundle)
                return this.tabs[this.product.tab].maxQty
            else
                return Math.floor(this.collectionValue / this.productCapacity)
        },
        title(){
            if(this.isSelected && this.maxQty == 1){
                return "Great Choice!"
            }
            else{
                if(this.canAdd){
                    return null
                }
                else {
                    return "This gift surpasses the value limit"
                }
            }
        },
        subtitle(){
            if(!this.isSelected && !this.canAdd){
                return "Would you like to empty cart and add only this gift?"
            }

            return null;
        },
        description(){
            if(this.product)
                return this.product.body_html;
            
            return '';
        },
        currentMainImage(){
            if(this.selectedImage){
                return this.selectedImage;
            }
            else {
               return this.product.images[0].src
            }
        },
        currentMainImageIndex(){
            if(this.selectedImage){
                let index = this.product.images.findIndex(x => x.src == this.selectedImage)
                if(index > -1)
                    return index
            }

            return 0
        },
        tabCapacity(){
            if(this.isBundle){
                return this.tabs[this.product.tab].currentQty;
            }

            return 0
        },
        bundleRemaining(){
            return this.tabs.reduce((prev, current) => prev + current.currentQty,0)
        },
        showAllVariants(){
            return this.product.tags.includes("show_all_variants");
        },
        allQtySelected(){
            if (!this.displaySizes || this.displaySizes.length === 0) return 0;

            return this.displaySizes.reduce((sum, x) => sum + parseInt(x.qty || 0, 10), 0);
        },
        shouldNextStep(){
            if (this.allQtySelected === 0) return false;

            if (!this.showAllVariants || !this.hasVariants) return false;

            const cartVariants = this.cartProducts
                .filter(x => x.id === this.product.id && x.variants && x.variants[0])
                .map(({ variants, qty }) => ({
                id: variants[0].id,
                qty
                }));

            if (cartVariants.length === 0) return false;

            return cartVariants.every(({ id, qty }) => {
                const match = this.displaySizes.find(x => x.id === id);
                return match && match.qty === qty;
            });
        }
    },
    methods:{
        closeModal(){
            this.$emit("closemodal");
        },
        selectProduct(isCleanAdd = false){
            if((!this.canAdd  || this.isSelected) && this.cartDiff == 0)
                return
            if(this.hasVariants && !this.selectedVariant){
                this.showAlert = true;
                return
            }
            if(this.extraProperties.length > 0 && this.propertiesSelected.length != this.extraProperties.length){
                this.showExtraAlert = true;
                return
            }
            for(let input of this.extraInputs){
                if(!this.formData[input.name] || this.formData[input.name] == ""){
                    this.showExtraAlert = true;
                    return;
                }
            }
            let productToSend = JSON.parse(JSON.stringify(this.product));
            productToSend.qty = this.selectedQty;
            if(this.hasVariants){
                productToSend.variants = [this.selectedVariant];
            }
            productToSend.properties = Object.assign({}, this.formData);
            if(isCleanAdd)
                this.$emit("cleanadd",productToSend);
            else
                this.$emit("selectproduct",productToSend);
        },
        addAllVariants(){
            let displaySum = this.displaySizes.reduce((sum,x) => sum + parseInt(x.qty) ,0);
            if(displaySum > this.maxQty){
                return
            }
            const productsToSend = this.displaySizes
            .filter(({ qty }) => qty > 0)
            .map(({ id,qty }) => {
                const variant = this.product.variants.find(v => v.id === id);
                if (!variant) return null;

                const clonedProduct = structuredClone(this.product);
                clonedProduct.variants = [variant];
                clonedProduct.qty = qty;
                return clonedProduct;
            })
            .filter(Boolean);
            productsToSend.forEach((product,i) => {
                if(i == 0)
                    this.$emit("cleanadd",product);
                else
                    this.$emit("selectproduct",product);
            });
        },
        checkout(){
            this.$emit("checkout")
        },
        selectImage(src){
            this.selectedImage = src;
        },
        incrementBoxQty(increment){
            if(increment){
                this.selectedQty++
            }
            else {
                if(this.selectedQty > 1){
                    this.selectedQty--;
                }
            }
        },
        nextStep(){
            this.$emit("nextstep");
            this.$emit("closemodal");
        },
        changeProperty(event,properties){
            this.$emit("changevariant",{name:properties.name,value:event.target.value,id:this.product.id});
        },
        validateVariantQty(index) {
            let maxQty = this.displaySizes[index].maxQty;
            let currentQty = this.displaySizes[index].qty;
            let displaySum = this.displaySizes.reduce((sum,x) => sum + parseInt(x.qty) ,0);

            // Prevent negative numbers
            if (currentQty < 0) {
                this.displaySizes[index].qty = 0;
            }

            // Enforce max limit
            if (currentQty > maxQty) {
                this.displaySizes[index].qty = maxQty;
            }
            if(displaySum > this.maxQty){
                this.displaySizes[index].qty -= (displaySum - this.maxQty);
            }
        },
    },
    mounted(){
        let selected = this.cartProducts.find(x => x.id == this.product.id);
        if(selected && selected.qty){
            this.selectedQty = selected.qty;
        }
        this.displaySizes = this.product.variants.map(x => {
            const variantProduct = this.cartProducts.find(y => y.variants[0]?.id === x.id);
            return {
                name: x.title,
                qty: variantProduct?.qty ?? 0, 
                maxQty: x.inventory_quantity,
                id: x.id
            };
        });
    }
}
</script>

<style>
.product-modal{
    background-color: #0000001F!important;
    display: block;
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding: 45px 0;
 }

 .product-modal-container{
    width: 60%;
    border-radius: 20px;
    max-height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    overflow-y: scroll;
    box-shadow: 0px 0px 0px 1px #0000001f;
 }

 .product-modal-container .main-container{
    padding: 5%;
    width: 100%;
    display: flex;
    justify-content: space-between;
 }

 .product-modal-container .main-container .oops{
    font-size: 2vw;
    font-weight: bold;
    font-style: italic;
 }

 .product-modal-container .main-container .main-title{
    font-size: 1.3vw;
    line-height: 1.2;
    font-weight: 700;
    text-transform: uppercase;
    color: #5a3089;
    margin-bottom: 3%;
 }

 .product-modal-container .main-container .subtitle{
    font-size: 1.5vw;
    text-align: center;
    margin-bottom: 5%;
 }

 .product-modal-container .main-container .first-container,.product-modal-container .main-container .second-container{
    width: 48%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
 }

 .image-container{
    width: 100%;
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
 }

 .image-container .main-image{
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    background-color: #f6f6f6;
 }

 .product-modal .close{
    position: absolute;
    float: unset;
    top: 2%;
    right: 2%;
    width: 2vw;
    line-height: 1;
 }

 .product-modal .product-title{
    font-size: 2vw;
    color: #0f0c38;
    font-weight: 700;
    line-height: 1;
 }

 .product-modal .main-description{
    margin: 5% 0%;
    background-color: #f6f6f6;
    padding: 10px;
    font-size: 1vw;
    color: #0f0c38;
    max-height: 80%;
    overflow-y: auto;
    width: 100%;
 }

 .product-modal .buttons-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
 }

 .product-modal .buttons-container button{
    width: 100%;
 }

    .extra-images-container{
        width: 100%;
        display: flex;
        gap: 10px;
    }

    .extra-image{
        width: 15%;
        max-width: 30%;
        flex: 1;
        background-color: #f6f6f6;
        cursor: pointer;
        object-fit: contain;
    }

    .extra-image.selected{
        border: 1px solid black;
    }

    .box-qty-input-container{
        width: 50%;
        display: flex;
        justify-content: flex-start;
        margin-top: 2%;
    }

    .box-qty-input-container input{
        background-color: #fff;
        border: 1px solid #e4e4e7 !important;
        border-radius: 4px !important;
        height: unset !important;
        padding: 1% 2% !important;
        text-align: center;
        font-size: 1.3vw;
        width: 40% !important;
        line-height: 1.5;
        -moz-appearance: textfield;
        color: #0f0c38;
    }

    .box-qty-input-container button{
        background-color: #fff;
        border: 1px solid #e4e4e7;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2vw;
        padding: 0 4%;
        line-height: 1;
        margin: 0 2%;
        color: #0f0c38;
        min-width: 25px;
    }

    .box-qty-input-container button:hover{
        background-color:#faf7fe
    }
    .box-qty-input-container button:disabled{
        opacity:.6
    }

    .box-qty-input-container input::-webkit-inner-spin-button,
    .box-qty-input-container input::-webkit-outer-spin-button{
        -webkit-appearance:none;
        margin:0
    }

    .variant-text{
        margin-top: 1rem;
        font-size: 1.15vw;
    }

    .variant-text.red{
        color: red;
    }

    .variant-container{
    width: 100%;
}

.variant-title{
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
    color: #0f0c38;
    padding: 2% 0%;
}

.sizes-selection-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin: 3% 0;
    padding: 0% 5%;
}

.size-selection{
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.size-selection p{
    font-size: 1.15vw;
    font-weight: bold;
    line-height: 1;
}

.size-selection .in-stock{
    color: #581C87;
    font-style: italic;
    font-weight: normal;
}


.size-selection input{
    background: unset;
    background-color: white;
    appearance: auto;
    height: unset !important;
    padding: 5px !important;
    border-radius: 4px !important;
    width: 50px;
    min-width: 50px;
    line-height: 1;
    font-size: 12px;
}

 @media only screen and (max-device-width: 767px){
    .product-modal-container{
        width: 85%;
        height: auto;
        max-height: 100%;
    }

    .product-modal-container .main-container{
        flex-direction: column;
        padding: 10% 5%;
    }

    .product-modal-container .main-container .first-container, .product-modal-container .main-container .second-container{
        width: 100%;
    }

    .product-modal .purple-link{
        font-size: 3vw
    }

    .product-modal-container .main-container .subtitle{
        font-size: 3.5vw;
        text-align: center;
    }

    .product-modal .product-title{
        font-size: 6vw;
        text-align: center;
        margin-bottom: 5%;
    }

    .product-modal-container .main-container .main-title{
        text-align: center;
        font-size: 4vw;
        margin-bottom: 5%;
    }

    .product-modal-container .main-container .oops{
        font-size: 4.5vw;
        text-align: center;
    }

    .product-modal .main-description{
        font-size: 3vw;
    }

    .product-modal .main-description > p,.product-modal .main-description > span{
        max-height: 15vh;
        display: block;
    }

    .product-modal-container .main-container .second-container{
        flex-direction: column-reverse;
        margin-top: 5%;
    }

    .product-modal-container .main-container .second-container.reverse{
        flex-direction: column;
    }

    .box-qty-input-container{
        justify-content: center;
        width: 100%;
        margin-bottom: 5%;
    }

    .box-qty-input-container input{
        font-size:4.5vw;
        width:20%!important
    }

    .box-qty-input-container button{
        font-size:5vw;
        padding:0 8%;
        line-height:1.3
    }

    .product-modal .close{
        width: 5vw;
        right: 5%;
    }

    .product-modal .buttons-container button{
        padding: 2%;
    }

    .happybox-button.green:hover{
        background-color: #5cffc0;
    }

    .variant-text{
        font-size: 3.5vw;
    }

    .variant-title{
        font-size: 3.5vw;
    }

    .size-selection{
        width: unset
    }

    .size-selection p{
        font-size: 3vw;
    }
 }


</style>